module.exports = __webpack_public_path__ + "static/work29-f4d4a1ae8c698ae402875b417430a44e.jpg";